import { initialState, RootState } from '@store/index';

export const selectRootState = state => state;

export const selectStateLoading = (state: RootState = initialState) =>
  state.cmsPages.loading || state.pageMetas.loading;
